import { ToggleButton } from "primereact/togglebutton";

export function ToggleIcon({icon,checked,onChange})
{
    return(
        <ToggleButton size="small" checked={checked} onIcon={icon} offIcon={icon} onLabel="" offLabel="" onChange={onChange}/>
    );
}